import { render, staticRenderFns } from "./BestRxForm.vue?vue&type=template&id=552c2399&scoped=true&"
import script from "./BestRxForm.vue?vue&type=script&lang=js&"
export * from "./BestRxForm.vue?vue&type=script&lang=js&"
import style0 from "./BestRxForm.vue?vue&type=style&index=0&id=552c2399&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552c2399",
  null
  
)

export default component.exports